'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductFixedBar = function ProductFixedBar(el) {
  (0, _classCallCheck3.default)(this, ProductFixedBar);

  var content = (0, _functional.getElement)('body');
  var fixedButton = (0, _functional.getElement)('.prd-FixedBar');

  var logElementPosition = function logElementPosition() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    var submitButton = document.querySelector('.prd-ProductOffers_Submit');
    if (submitButton) {
      var rect = submitButton.getBoundingClientRect();
      var atBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;
      if (rect.bottom < 0 && !atBottom) {
        content.classList.add('lyt-FixedBar-visible');
        fixedButton.setAttribute('aria-hidden', 'false');
      } else if (atBottom) {
        content.classList.remove('lyt-FixedBar-visible');
        fixedButton.setAttribute('aria-hidden', 'true');
      } else {
        content.classList.remove('lyt-FixedBar-visible');
        fixedButton.setAttribute('aria-hidden', 'true');
      }
    }
  };

  var productThumbs = (0, _functional.getElement)('.prd-ProductImage_Thumbs');
  var fixedBarButton = (0, _functional.getElement)('.prd-FixedBar_Button');
  var productFormButton = (0, _functional.getElement)('[data-add-to-cart]');

  var buttonClick = function buttonClick() {
    if (productFormButton.getAttribute('disabled')) {
      productThumbs.scrollIntoView({ behavior: 'smooth' });
    } else {
      productFormButton.click();
    }
  };

  document.addEventListener('scroll', logElementPosition);
  fixedBarButton.addEventListener('click', buttonClick);
};

exports.default = ProductFixedBar;